const DebitCard = ({ width, height, color }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 52 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.75 12.2485C35.75 11.8176 35.9212 11.4042 36.226 11.0995C36.5307 10.7947 36.944 10.6235 37.375 10.6235H43.875C44.306 10.6235 44.7193 10.7947 45.024 11.0995C45.3288 11.4042 45.5 11.8176 45.5 12.2485V15.4985C45.5 15.9295 45.3288 16.3428 45.024 16.6476C44.7193 16.9523 44.306 17.1235 43.875 17.1235H37.375C36.944 17.1235 36.5307 16.9523 36.226 16.6476C35.9212 16.3428 35.75 15.9295 35.75 15.4985V12.2485Z"
        fill={color}
      />
      <path
        d="M6.5 0.873535C4.77609 0.873535 3.12279 1.55835 1.90381 2.77734C0.68482 3.99633 0 5.64963 0 7.37354L0 33.3735C0 35.0974 0.68482 36.7507 1.90381 37.9697C3.12279 39.1887 4.77609 39.8735 6.5 39.8735H45.5C47.2239 39.8735 48.8772 39.1887 50.0962 37.9697C51.3152 36.7507 52 35.0974 52 33.3735V7.37354C52 5.64963 51.3152 3.99633 50.0962 2.77734C48.8772 1.55835 47.2239 0.873535 45.5 0.873535H6.5ZM48.75 7.37354V23.6235H3.25V7.37354C3.25 6.51158 3.59241 5.68493 4.2019 5.07544C4.8114 4.46594 5.63805 4.12354 6.5 4.12354H45.5C46.362 4.12354 47.1886 4.46594 47.7981 5.07544C48.4076 5.68493 48.75 6.51158 48.75 7.37354ZM45.5 36.6235H6.5C5.63805 36.6235 4.8114 36.2811 4.2019 35.6716C3.59241 35.0621 3.25 34.2355 3.25 33.3735V30.1235H48.75V33.3735C48.75 34.2355 48.4076 35.0621 47.7981 35.6716C47.1886 36.2811 46.362 36.6235 45.5 36.6235Z"
        fill={color}
      />
    </svg>
  );
};
export default DebitCard;
